// ./src/components/generic/HeightSelector/HeightSelector.tsx
import React from "react";
import { Select, SelectProps } from "@mantine/core";

const HEIGHT_OPTIONS = [
  {
    value: "0rem",
    label: "None",
    description: "No height (hidden)",
  },
  {
    value: "2.5rem",
    label: "Small",
    description: "Small height (~40px)",
  },
  {
    value: "3.75rem",
    label: "Normal",
    description: "Normal height (~60px)",
  },
  {
    value: "5rem",
    label: "Large",
    description: "Large height (~80px)",
  },
] as const;

export interface HeightSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current height value */
  value: string | null | undefined;

  /** Callback when height changes */
  onChange: (value: string | null) => void;

  /** Whether to show descriptions in the dropdown */
  withDescriptions?: boolean;
}

export const HeightSelector: React.FC<HeightSelectorProps> = ({
  value,
  onChange,
  withDescriptions = false,
  placeholder = "Select height",
  label,
  description,
  error,
  ...selectProps
}) => {
  // Prepare select data with optional descriptions
  const selectData = HEIGHT_OPTIONS.map((option) => {
    let label: string = option.label;

    if (withDescriptions) {
      label = `${option.label} - ${option.description}`;
    }

    return {
      value: option.value,
      label,
    };
  });

  return (
    <Select
      {...selectProps}
      label={label}
      description={description}
      error={error}
      data={selectData}
      value={value || null}
      onChange={onChange}
      placeholder={placeholder}
      clearable={false}
    />
  );
};

// Export height options for use in other components
export { HEIGHT_OPTIONS };
